var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/asset-config.tsx
import React from "react";
import { getConfig, useConfigProperty } from "@leagueplatform/config";
import { Image } from "@leagueplatform/genesis-commons";
var defaultAssets = {};
function setDefaultAssets(assetMap) {
  Object.entries(assetMap).forEach(([key, value]) => {
    defaultAssets[key] = value;
  });
}
function renderComponent(asset, props) {
  const { alt = "" } = props;
  if (typeof asset !== "string") {
    const Component = asset;
    if (props) {
      return /* @__PURE__ */ React.createElement(Component, __spreadValues({}, props));
    }
    return /* @__PURE__ */ React.createElement(Component, null);
  }
  return /* @__PURE__ */ React.createElement(
    Image,
    __spreadProps(__spreadValues({}, props), {
      src: asset,
      alt
    })
  );
}
function doHandleStaticAsset(assetKey, assetOverrides, options) {
  const asset = assetOverrides[assetKey] || defaultAssets[assetKey];
  if (!asset) {
    throw new Error(
      `It looks like the asset "${assetKey}" you are trying to render is not set in the assets map (e.g. asset-map.tsx). Please review your asset map and make sure all assets are defined.`
    );
  }
  const { isComponent, props = {} } = options || {};
  if (isComponent) {
    return renderComponent(asset, props);
  }
  if (typeof asset !== "string" && !isComponent) {
    throw new Error(
      `It looks like the asset "${assetKey}" you are trying to render is a React Component or function. Set isComponent to true in order to do so.`
    );
  }
  return asset;
}
function handleStaticAsset(assetKey, options) {
  var _a;
  return doHandleStaticAsset(
    assetKey,
    ((_a = getConfig().config.assets) == null ? void 0 : _a.overrides) || {},
    options
  );
}
function useStaticAsset(assetKey, options) {
  return doHandleStaticAsset(
    assetKey,
    useConfigProperty("assets.overrides", {}),
    options
  );
}
export {
  handleStaticAsset,
  setDefaultAssets,
  useStaticAsset
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/asset-config'] = window.leagueSDKsPresent['@leagueplatform/asset-config'] || [];
    window.leagueSDKsPresent['@leagueplatform/asset-config'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/asset-config'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/asset-config module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map